var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "timer-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8349 30.4009H3.16823C2.6349 30.4009 2.10156 30.0009 2.10156 29.3342C2.10156 28.6676 2.50156 28.2676 3.16823 28.2676H17.8349C23.8349 28.2676 28.7682 23.3342 28.7682 17.3342C28.7682 11.3342 23.8349 6.40091 17.8349 6.40091C12.2349 6.40091 7.4349 10.6676 6.76823 16.1342C6.76823 16.6676 6.2349 17.0676 5.70156 17.0676C5.16823 17.0676 4.76823 16.5342 4.76823 16.0009C5.56823 9.33425 11.1682 4.26758 17.8349 4.26758C25.0349 4.26758 30.9016 10.1342 30.9016 17.3342C30.9016 24.5342 25.0349 30.4009 17.8349 30.4009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.1672 8.26706C24.9005 8.26706 24.6339 8.13372 24.5005 8.00039C24.1005 7.60039 24.1005 6.93372 24.5005 6.53372L25.8339 5.20039C26.2339 4.80039 26.9005 4.80039 27.3005 5.20039C27.7005 5.60039 27.7005 6.26706 27.3005 6.66706L25.9672 8.00039C25.7005 8.26706 25.4339 8.26706 25.1672 8.26706ZM9.16719 8.26706C8.90052 8.26706 8.63385 8.26706 8.50052 8.00039L7.16719 6.66706C6.76719 6.26706 6.76719 5.73372 7.16719 5.33372C7.56719 4.93372 8.10052 4.93372 8.50052 5.33372L9.83385 6.66706C10.2339 7.06706 10.2339 7.60039 9.83385 8.00039C9.70052 8.26706 9.43385 8.26706 9.16719 8.26706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.1677 12.6665L19.8344 15.9999C19.9677 16.3999 20.101 16.7999 20.101 17.3332C20.101 18.9332 18.7677 20.2665 17.1677 20.2665C15.5677 20.2665 14.2344 18.9332 14.2344 17.3332C14.2344 15.7332 15.5677 14.3999 17.1677 14.3999C17.5677 14.3999 18.101 14.5332 18.501 14.6665L21.8344 11.3332C22.2344 10.9332 22.901 10.9332 23.301 11.3332C23.5677 11.7332 23.5677 12.2665 23.1677 12.6665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.1682 5.59961C16.6349 5.59961 16.1016 5.19961 16.1016 4.53294V2.66628C16.1016 2.13294 16.5016 1.59961 17.1682 1.59961C17.8349 1.59961 18.2349 1.99961 18.2349 2.66628V4.66628C18.1016 5.19961 17.7016 5.59961 17.1682 5.59961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.8297 3.73294H14.4964C13.963 3.73294 13.4297 3.33294 13.4297 2.66628C13.4297 1.99961 13.8297 1.59961 14.4964 1.59961H19.8297C20.363 1.59961 20.8964 1.99961 20.8964 2.66628C20.8964 3.33294 20.363 3.73294 19.8297 3.73294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.16823 21.0669H3.16823C2.6349 21.0669 2.10156 20.6669 2.10156 20.0003C2.10156 19.3336 2.50156 18.9336 3.16823 18.9336H7.16823C7.70156 18.9336 8.2349 19.3336 8.2349 20.0003C8.2349 20.6669 7.70156 21.0669 7.16823 21.0669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.8349 26.4009H3.16823C2.6349 26.4009 2.10156 26.0009 2.10156 25.3342C2.10156 24.6676 2.50156 24.2676 3.16823 24.2676H9.8349C10.3682 24.2676 10.9016 24.6676 10.9016 25.3342C10.9016 26.0009 10.3682 26.4009 9.8349 26.4009Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime4);
export default __webpack_public_path__ + "static/media/time4.8a35a0d3512d4028c4cffc7505d8b551.svg";
export { ForwardRef as ReactComponent };